/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ filter: NonNullable<unknown> }} Filter_RemoveInputs */

const en_filter_remove = /** @type {(inputs: Filter_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.filter}`)
};

const de_filter_remove = /** @type {(inputs: Filter_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.filter} entfernen`)
};

/**
* | output |
* | --- |
* | "Remove {filter}" |
*
* @param {Filter_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_remove = /** @type {((inputs: Filter_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_remove(inputs)
	return en_filter_remove(inputs)
});